module.exports = __webpack_public_path__ + "assets/img/29_235_big.7f100850.jpg";